export default __webpack_public_path__ + "static/media/bg-morning.6027a55d.jpg";